// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const COMPUTED_COLUMN_STEP_SHAPES = [
  {
    stepType: PipelineStepType.COMPUTED_COLUMN,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      formula: {
        kind: 'shape',
        required: true,
        fields: {
          formulaText: {
            kind: 'string',
            required: true
          },
          formulaAst: {
            kind: 'taggedUnion',
            required: true,
            tagKey: 'type',
            choices: [
              {
                kind: 'shape',
                required: true,
                fields: {
                  type: {
                    kind: 'string',
                    required: true,
                    value: 'COLUMN_REFERENCE'
                  },
                  value: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  type: {
                    kind: 'string',
                    required: true,
                    value: 'STRING_LITERAL'
                  },
                  value: {
                    kind: 'string',
                    required: true
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  type: {
                    kind: 'string',
                    required: true,
                    value: 'NUMBER_LITERAL'
                  },
                  value: {
                    kind: 'number',
                    required: true
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  type: {
                    kind: 'string',
                    required: true,
                    value: 'BOOLEAN_LITERAL'
                  },
                  value: {
                    kind: 'boolean',
                    required: true
                  }
                }
              },
              {
                kind: 'shape',
                required: true,
                fields: {
                  type: {
                    kind: 'string',
                    required: true,
                    value: 'OPERATION'
                  },
                  operation: {
                    kind: 'enum',
                    required: true,
                    choices: [
                      'ABSOLUTE_VALUE',
                      'ADD',
                      'AND',
                      'AVERAGE',
                      'CEILING',
                      'CONTAINS',
                      'COUNT',
                      'COUNT_BLANKS',
                      'DATE_CONVERT',
                      'DATE_DIFF',
                      'DATE_TRUNC',
                      'DATE_TRUNC_INTERVAL',
                      'DIVIDE',
                      'EQUALS',
                      'EXP',
                      'EXTRACT',
                      'FACTORIAL',
                      'FLOOR',
                      'GEOMETRIC_MEAN',
                      'GREATER_THAN',
                      'GREATER_THAN_OR_EQUALS',
                      'IF',
                      'IS_BLANK',
                      'LEFT',
                      'LENGTH',
                      'LESS_THAN',
                      'LESS_THAN_OR_EQUALS',
                      'LOG_10',
                      'LOG_2',
                      'MAX',
                      'MEDIAN',
                      'MIN',
                      'MODE',
                      'MODULUS',
                      'MULTIPLY',
                      'NATURAL_LOG',
                      'NOT_EQUALS',
                      'NULL_VALUE',
                      'OR',
                      'PI',
                      'POWER',
                      'PRODUCT',
                      'RIGHT',
                      'ROUND',
                      'SPLIT',
                      'STANDARD_DEVIATION',
                      'STANDARD_ERROR',
                      'SUBSTITUTE',
                      'SUBSTRING',
                      'SUBTRACT',
                      'SUM',
                      'TEXT_JOIN',
                      'VARIANCE',
                      'VLOOKUP'
                    ]
                  },
                  arguments: {
                    kind: 'array',
                    required: true,
                    elementSpec: {
                      kind: 'anything',
                      required: true
                    }
                  }
                }
              }
            ]
          }
        }
      },
      newColumnName: {
        kind: 'string',
        required: true
      },
      replaceColumn: {
        kind: 'columnReference',
        required: false,
        inputDataName: 'Input dataset',
        validationOptions: null
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
